import {  FastField, Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import * as YUP from "yup";
import FormikControl from "./components/formikComponents/FormikControl";
import { Link } from "react-router";
import axios from "axios";

const initialValues = {
  email: "",
  password: "",
  remember: false,
};

const onSubmit = (values) => {
  console.log(values);
};
const validationSchema = YUP.object({
  email: YUP.string()
    .required("لطفا این قسمت را پرکنید!")
    .email("لطفا فرمت ایمیل را رعایت کنید. مثال: aaaa@bbb.ccc"),

  password: YUP.string()
    .required("لطفا این قسمت را پرکنید!")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "رمز عبور باید حداقل ۸ کاراکتر و شامل حروف بزرگ، کوچک و عدد باشد."
    ),
});

const Login = () => {
  const [isloading, setIsloading] = useState(true);
  useEffect(() => {
    document.title = "Login Formik";
    setTimeout(() => setIsloading(false), 1000);
  }, []);

  const handleGetUserData = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.log("No token found");
      return;
    }

    axios
      .get("https://authservice.azhadev.ir/api/auth/user", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("User Data:", response.data);
      })
      .catch((error) => {
        if (error.response) {
          console.error("خطایی وجود دارد!", error.response.data);
        } else {
          console.error("خطایی وجود دارد!", error.message);
        }
      });
  };

  return (
    <Fragment>
      <div
        className="preloader preloader-dark"
        style={{
          opacity: isloading ? 1 : 0,
          visibility: isloading ? "visible" : "hidden",
          transition: "opacity 0.5s ease, visibility 0.5s ease",
        }}
      >
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        validateOnBlur={true}
        validateOnChange={true}
      >
        {(formik) => {
          console.log(formik);
          return (
            <div id="main-wrapper" className="oxyy-login-register position-relative">
                      <button type="button" className="hanged_button btn btn-secondary"onClick={handleGetUserData}>لاگ اطلاعات کاربر</button>

              <div className="hero-wrap min-vh-100">
                <div className="hero-mask opacity-4 bg-secondary"></div>
                <div
                  className="hero-bg hero-bg-scroll"
                  style={{ backgroundImage: "url('../auth/img/login-bg-5.jpg')" }}
                ></div>
                <div className="hero-content d-flex min-vh-100">
                  <div className="container my-auto">
                    <div className="row position-relative">
                      <div className="col-md-9 col-lg-7 col-xl-5 mx-auto">
                        <div className="hero-wrap rounded shadow-lg p-4 py-sm-5 px-sm-5 my-4">
                          <div className="hero-mask opacity-9 bg-dark"></div>
                          <div className="hero-content">
                            <div className="logo mb-4">
                              <a
                                className="d-flex justify-content-center"
                                href="index.html"
                                title="Oxyy"
                              >
                                <img src="../auth/img/logo.png" alt="Oxyy" />
                              </a>
                            </div>
                            <Form
                              id="loginForm"
                              className="form-dark"
                              method="post"
                            >
                            

                              <FormikControl
                                name="email"
                                type="text"
                                icon="fas fa-envelope"
                                formik={formik}
                                control="input"
                                placeholder="آدرس ایمیل"
                                direction="ltr"
                              />
                             

                              <FormikControl
                                name="password"
                                type="password"
                                icon="fas fa-lock"
                                formik={formik}
                                control="input"
                                placeholder="رمز عبور"
                                direction="ltr"
                              />
                              <button
                                className="btn btn-primary btn-block shadow-none mt-4 mb-3"
                                type="submit"
                              >
                                ورود
                              </button>
                              <div className="row text-2 mt-4">
                                <div className="col-sm">
                                  <div className="form-check custom-control custom-checkbox">
                                    <FastField name="remember">
                                      {({ field }) => (
                                        <>
                                          <input
                                            id="remember-me"
                                            type="checkbox"
                                            className="custom-control-input"
                                            checked={field.value} 
                                            {...field} 
                                          />
                                          <label
                                            className="custom-control-label text-light"
                                            htmlFor="remember-me"
                                          >
                                            به خاطر سپردن
                                          </label>
                                        </>
                                      )}
                                    </FastField>
                                  </div>
                                </div>
                                <div className="col-sm text-right">
                                  <a className="btn-link text-light" href="#">
                                    فراموشی رمز عبور؟
                                  </a>
                                </div>
                              </div>
                            </Form>
                            <div className="d-flex align-items-center mt-2 mb-3">
                              <hr className="flex-grow-1 border-dark" />
                              <span className="mx-2 text-muted text-2">
                                ورود با
                              </span>
                              <hr className="flex-grow-1 border-dark" />
                            </div>
                            <div className="d-flex  flex-column align-items-center mb-3">
                              <ul className="social-icons social-icons-rounded">
                                <li className="social-icons-facebook">
                                  <a
                                    href="#"
                                    data-toggle="tooltip"
                                    data-original-title="Log In with Facebook"
                                  >
                                    <i className="fab fa-facebook-f"></i>
                                  </a>
                                </li>
                                <li className="social-icons-twitter">
                                  <a
                                    href="#"
                                    data-toggle="tooltip"
                                    data-original-title="Log In with Twitter"
                                  >
                                    <i className="fab fa-twitter"></i>
                                  </a>
                                </li>
                                <li className="social-icons-google">
                                  <a
                                    href="#"
                                    data-toggle="tooltip"
                                    data-original-title="Log In with Google"
                                  >
                                    <i className="fab fa-google"></i>
                                  </a>
                                </li>
                                <li className="social-icons-linkedin">
                                  <a
                                    href="#"
                                    data-toggle="tooltip"
                                    data-original-title="Log In with Linkedin"
                                  >
                                    <i className="fab fa-linkedin-in"></i>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <p className="text-2 text-muted text-center mb-0">
                              حساب ندارید؟{" "}
                              <Link
                                className="btn-link text-light text-3"
                                to="/Register"
                              >
                                ثبت نام
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    </Fragment>
  );
};

export default Login;
